module.exports = __webpack_public_path__ + "img/ico_assistente.26324ff2.svg";